export default __webpack_public_path__ + "static/media/yellow-dot-single.4e217f64.svg";